import React from "react";
import { IconMenu, FlatButton, FontIcon } from "material-ui";

const BUTTON_STYLE = {
  marginLeft: 12,
  minWidth: 40
};

const ICON_BUTTON_STYLE = {
  height: "100%",
  display: "inline-block",
  verticalAlign: "middle",
  lineHeight: "36px",
  fontSize: 15
};

const MENU_STYLE = {
  maxWidth: "90vw",
  textAlign: "left",
  zIndex: 6000
};

const CogButtonMenu = ({ children, ...rest }, { isLarge }) => {
  const CogButton = (
    <FlatButton style={BUTTON_STYLE}>
      <FontIcon className="icon-cog" style={ICON_BUTTON_STYLE} />
    </FlatButton>
  );

  return (
    <IconMenu
      iconButtonElement={CogButton}
      menuStyle={MENU_STYLE}
      desktop={isLarge}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      targetOrigin={{ vertical: "top", horizontal: "right" }}
      {...rest}
    >
      {children}
    </IconMenu>
  );
};

CogButtonMenu.contextTypes = {
  isLarge: React.PropTypes.bool
};

export default CogButtonMenu;



// WEBPACK FOOTER //
// ./src/app/components/partials/cog-button-menu.jsx